<template lang="pug">
md-layout(md-flex='100')
  md-layout(md-flex='90', md-flex-offset='5')
    md-card.md-table-card.content-table
      md-card-header.md-title
        | Billing reporting
      form.search-form(novalidate, @submit.stop.prevent='searchForBilling')
        md-layout(:md-gutter='24')
          md-layout(md-flex='20', md-flex-small='30')
            md-input-container
              label(for='criteria') Account
              md-select#criteria(v-model='filters.accountId', @selected='searchForBilling' )
                md-option(:value="account._id" v-for='account in accounts' :key="account._id" ) {{ account.name }}
          md-layout(md-flex='20', md-flex-small='30')
            md-input-container
              label(for='criteria') Month
              md-select#criteria(v-model='filters.month', @selected='searchForBilling' )
                md-option(:value="month.value" v-for='month in months' :key="month.value" ) {{ month.name }}
          md-layout(md-flex='20', md-flex-small='30')
            md-input-container
              label(for='criteria') Year
              md-select#criteria(v-model='filters.year', @selected='searchForBilling' )
                md-option(:value="year.value" v-for='year in years' :key="year.value" ) {{ year.value }}
          md-layout(md-flex='10', md-flex-small='10', md-flex-xsmall='100', md-vertical-align='center', md-align-xsmall='center')
            md-button.search-btn.md-raised.md-icon-button.btn(type='submit', :disabled='loading || $v.$invalid')
              md-icon.icon(md-iconset="fa fa-search")

      stitch-loader(:loading='loading', :size='45')
        .table
          div.titleLine.styleRow
            p.rowElements Bandwidth Count
            p.rowElements Bandwidth GB
            p.rowElements Bandwidth Total cost
            p.rowElements MediaConvert Total
            p.rowElements TOTAL BILL
          div.styleRow.colorHover
            div.rowElements {{ (bill.billingBandwith.missRequestsCount != 'no data') ? (bill.billingBandwith.missRequestsCount + bill.billingBandwith.hitTotalRequestsCount) : 'no data'}}
            div.rowElements {{ (bill.billingBandwith.missTotalGB != 'no data') ? (`${bill.billingBandwith.missTotalGB + bill.billingBandwith.hitTotalGB} GB`) : 'no data'}}
            div.rowElements {{ (calculateBandwidthTotal() != 'NaN') ? `$${calculateBandwidthTotal()}` : 'no data' }}
            div.rowElements {{ (mediaConvertTotal() != 'NaN') ? `$${mediaConvertTotal()}` : 'no data' }}
            div.rowElements {{ (bill.total != 'no data') ? (`$${bill.total}`) : 'no data'}}
</template>

<script>
import { validationMixin } from "vuelidate";
import reportService from "../../services/reportService";
import stitchLoader from "../../shared-components/Loader";
import { generateMonths, generateYears } from "./dateUtils";

export default {
  mixins: [validationMixin],
  components: {
    stitchLoader,
  },
  data() {
    return {
      months: generateMonths(),
      years: generateYears(),
      accounts: [],
      bill: {
        accountId: "",
        billingBandwith: {
          missRequestsCount: 0,
          missTotalGB: 0,
          missAWSPricePerGB: 0,
          hitTotalRequestsCount: 0,
          hitAWSPricePerGB: 0,
          AWSPricePer10_000Requests: 0,
          hitTotalGB: 0,
        },
        billingTranscode: {
          mediaConvert: {
            sdMinutesTranscoded: 0,
            sdAWSPricePerMinuteTranscoded: 0,
            hdMinutesTranscoded: 0,
            hdAWSPricePerMinuteTranscoded: 0,
          },
          billingMediaConvert: {
            mediaConvertPricePerMinute: 0,
            mediaConvertTotalMinutes: 0,
          },
        },

        total: 0,
      },
      loading: false,
      sort: {
        name: "date",
        type: "asc",
      },
      totalEntries: 0,
      currentPagination: {
        size: 50,
        page: 1,
      },
      filters: {
        accountId: "",
        month: "",
        year: "",
      },
    };
  },
  validations: {},
  computed: {
    searchParams() {
      const params = {
        offset: this.currentPagination.size * (this.currentPagination.page - 1),
        limit: this.currentPagination.size,
      };
      return params;
    },
  },
  methods: {
    searchForBilling() {
      if (
        this.filters.accountId != "" &&
        this.filters.month != "" &&
        this.filters.year != ""
      ) {
        this.loading = true;
        this.resetBill();

        reportService
          .getBillingOfAccount(this.filters)
          .then((response) => {
            if (response.data.data.length != 0) {
              this.bill = response.data.data[0];
              this.calculateTotal();
            } else {
              this.bill = {
                accountId: "",
                billingBandwith: {
                  missRequestsCount: "no data",
                  missTotalGB: "no data",
                  missAWSPricePerGB: "no data",
                  hitTotalRequestsCount: "no data",
                  hitAWSPricePerGB: "no data",
                  AWSPricePer10_000Requests: "no data",
                  hitTotalGB: "no data",
                },
                billingTranscode: {
                  mediaConvert: {
                    sdMinutesTranscoded: "no data",
                    sdAWSPricePerMinuteTranscoded: "no data",
                    hdMinutesTranscoded: "no data",
                    hdAWSPricePerMinuteTranscoded: "no data",
                  },
                  billingMediaConvert: {
                    mediaConvertPricePerMinute: "no data",
                    mediaConvertTotalMinutes: "no data",
                  },
                },
                total: "no data",
              };
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.error("Error while retrieving billing report", error);
          });
      }
    },
    resetBill() {
      this.bill = {
        accountId: "",
        billingBandwith: {
          missRequestsCount: 0,
          missTotalGB: 0,
          missAWSPricePerGB: 0,
          hitTotalRequestsCount: 0,
          hitAWSPricePerGB: 0,
          AWSPricePer10_000Requests: 0,
          hitTotalGB: 0,
        },
        billingTranscode: {
          mediaConvert: {
            sdMinutesTranscoded: 0,
            sdAWSPricePerMinuteTranscoded: 0,
            hdMinutesTranscoded: 0,
            hdAWSPricePerMinuteTranscoded: 0,
          },
        },
        billingMediaConvert: {
          mediaConvertPricePerMinute: 0,
          mediaConvertTotalMinutes: 0,
        },
        total: 0,
      };
    },
    calculateMiss() {
      return parseFloat(
        this.bill.billingBandwith.missTotalGB *
        this.bill.billingBandwith.missAWSPricePerGB
      ).toFixed(2);
    },
    calculateHit() {
      return parseFloat(
        this.bill.billingBandwith.hitTotalGB *
        this.bill.billingBandwith.hitAWSPricePerGB
      ).toFixed(2);
    },
    calculateBandwidthTotal() {
      return parseFloat(parseFloat(this.calculateMiss(), 10) + parseFloat(this.calculateHit(), 10)).toFixed(2);
    },
    mediaConvertTotal() {
      const hdMinutes = this.bill.billingTranscode !== undefined ? this.bill.billingTranscode.mediaConvert.hdMinutesTranscoded : 0
      const sdMinutes = this.bill.billingTranscode !== undefined ? this.bill.billingTranscode.mediaConvert.sdMinutesTranscoded  : 0
      //--- aws pricing per minutes ---
      return ((hdMinutes * 0.015) + (sdMinutes * 0.0075)).toFixed(2)
    },

    calculateTotal() {
      const sumTotal = (parseFloat(this.calculateMiss(), 10) +
        parseFloat(this.calculateHit(), 10) +
        parseFloat(this.mediaConvertTotal(), 10));
      this.bill.total = sumTotal.toFixed(2);
    },
  },
  mounted() {
    reportService
      .getAccounts(this.searchParams)
      .then((response) => {
        this.accounts = response.data.accounts.sort((a, b) => {
          let fa = a.name.toLowerCase(),
            fb = b.name.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
        this.loading = false;
      })
      .catch((error) => {
        console.error("Error while retrieving billing report", error);
      });
  },
};
</script>

<style lang="scss" scoped>
.search-form {
  margin-top: 20px;
  width: 100%;
  display: flex;
}

.table {
  margin-top: 20px;

  .title {
    margin-left: 15%;
    font-size: 1.5em;
  }

  .bold {
    font-weight: 800;
  }

  .end {
    text-align: right;
  }
}

.content-table {
  width: 100%;
  margin-top: 20px !important;
  padding-left: 10px;
  padding-right: 10px;
  margin: auto;
}

.md-table {

  .md-sortable.md-sorted,
  .md-sortable:hover {
    color: #0198cf;
  }
}

.styleRow p {
  font-weight: 600;
}

.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
}

.colorHover:hover {
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}
</style>



// WEBPACK FOOTER //
// src/shared-components/report/BillingTable.vue